<script>
	// Stores
	import { 
		linkMapa, 
		linkWaze, 
		linkUber, 
		linkAV, 
		linkAPI, 
		linkTelefone,
		tagsSEO, 
		textEndereco, 
		textTelefone, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		textWhatsappGeral, 
		linkWhatsappGeral,
		textWhatsappFinanceiro, 
		linkWhatsappFinanceiro,
		textWhatsappComercial,
		linkWhatsappComercial,
		textWhatsappAdm,
		linkWhatsappAdm,
		linkFacebook,
		linkInstagram,
		linkPoliticaPrivacidade
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	
	// Code
	let social = [
		{
			title: 'Facebook',
			icon: '<i class="fab fa-facebook-square"></i>',
			link: $linkFacebook,
			target: '_blank',
		},
		{
			title: 'Instagram',
			icon: '<i class="fab fa-instagram"></i>',
			link: $linkInstagram,
			target: '_blank',
		}
	];

	let links = [
		{
			title: '2ª Via de Boletos e Extratos',
			link: $linkAV,
			target: '_blank',
		},        
		{
			title: 'Documentação para Alugar',
			link: '/documentacao-necessaria',
		},
		{
			title: 'Cadastre seu Imóvel',
			link: '/anuncie',
		},
		{
			title: 'Solicite um Imóvel',
			link: '/solicite-imovel',
		},
		{
			title: 'Solicite Proposta Condomínio',
			link: '/solicite-proposta',
		},
		{
			title: 'Envie seu Contato',
			link: '/contato',
		},
		{
			title: 'Política de Privacidade',
			link: $linkPoliticaPrivacidade,
			target: '_blank',
		},
	];

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-waze"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-uber"></i>',
			link: $linkUber,
		}
	];

	let contatos = [
		{
			title: 'Geral <b>' + $textTelefone + '</b>',
			icon: '<i class="fas fa-phone"></i>',
			href: $linkTelefone,
			target: '_blank'
		},
		{
			title: 'Whatsapp <b>' + $textWhatsappGeral + '</b>',
			icon: '<i class="fab fa-whatsapp"></i>',
			href: $linkWhatsappGeral,
			target: '_blank'
		},
		{
			title: 'Área do Cliente',
			classe: 'btn btn-primary',
			icon: '<i class="fas fa-barcode-alt"></i>',
			href: $linkAV,
			target: '_blank'
		}
	];    
</script>

<footer class="mt-40">
	<section class="footer-banner">
		<div class="container">
			<div class="footer-banner__box">
				{#each contatos as contato}
					<a class="footer-banner__item" href="{contato.href}" title="Contato via {contato.title} - {$textSite}" target="_blank">
						{@html contato.icon} {@html contato.title}
					</a>
				{/each}
			</div>
		</div>
	</section>
	<section class="informacoes">
		<div class="container">
			<div class="itens text-center">
				<div class="item text-lg-left pr-20 sm-pr-0 ">
					<a href="/sobre"><img src="/assets/images/rodapeSede.jpg" alt="Sede da {$textSite}" /></a>
				</div>
				<div class="item text-lg-left">
					<h2 class="subtitle color-accent mb-15"><b>SP Imobiliária</b></h2>
					<p class="">{@html $tagsSEO}</p>
					<p>
					{#each social as item}
						<a class="mr-10 text--large" href="{item.link}" use:link replace title="Ir para {item.title}" target="{item.target}">{@html item.icon != null ? item.icon : ""}</a>
					{/each}
					</p>
				</div>
				<div class="item">
					<h2 class="subtitle color-accent mb-15"><b>Venha nos visitar</b></h2>
					<h3 class="subtitle"><i class="fas fa-clock"></i> <b>Atendimento</b></h3>
					<ul>
						<li>
							<p>{@html $textAtendimento}</p>
						</li>
					</ul>
					<h3 class="subtitle"><i class="fas fa-map-marker-alt"></i> <b>Endereço</b></h3>
					<ul>
						<li><p class="mb-0">{@html $textEndereco}</p></li>
					</ul>
					<ul class="list list--point">
						{#each localizacao as item}
						<li class="list-item">
							<a href="{item.link}" title="Endereço {$textSite} via {item.title}" target="_blank">
								{@html item.icon != null ? item.icon : ""} {item.title}
							</a>
						</li>
						{/each}
					</ul>
				</div>
				<div class="item text-lg-right">
					<h2 class="subtitle color-accent mb-15"><b>Acesso Rápido</b></h2>
					<ul>
						{#each links as item}
						<li>
							<a href="{item.link}" use:link replace title="Ir para {item.title}" target="{item.target}">
								{@html item.icon != null ? item.icon : ""} {item.title}
							</a>
						</li>
						{/each}
					</ul>
				</div>
			</div>
			<p class="hidden disclaimer mt-30">*Os anúncios de Venda são de responsabilidade exclusiva da Solucione Inteligência Imobilária.</p>
			<p class="copyright">© Copyright 2021 - {$textSite} - CRECI {$textCreci} - CNPJ {$textCNPJ} - Todos os Direitos Reservados - Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a></p>
		</div>
	</section>
</footer>